module.exports = "/_next/static/images/626629662f2aa76b51c124013f843223-image-left-lg.jpg.webp";